import styled from 'styled-components';
export var Label = styled.span.withConfig({
  displayName: "Label",
  componentId: "sc-1paxc1u-0"
})(["position:relative;font-size:13px;font-weight:700;line-height:40px;svg{position:absolute;top:0;right:-24px;transition:right 0.3s ease-in;}&:hover{svg{right:-25px;}a{opacity:1;}}"]);